<template>
  <div class="my-home-content3">
   <div>
      <h2>稳定、安全、先进的中台产品</h2>
      <span class="span13">Stable, safe and advanced middle-end products</span>
      <router-link :to="{path:'productCenter'}">
        <span class="span23" @click="go()">查看更多中台产品></span>
      </router-link>
    </div>
    <Row>
      <Col span="2"></Col>
      <Col span="20" style="padding: 0.5rem;">
            <div class="my-content3">
              <div class="box_hz">
                <Row :gutter="20" class="hz_g">
                  <Col span="18" class="home-content3-video1">
                  <div class="player_kuan1 kuan1">
                  <video id="my-player" ref="kuan1" class="kuan1" preload="auto"  webkit-playsinline="" playsinline="" x5-playsinline="" x-webkit-airplay="allow"   @mouseenter="play"  @mouseleave="pause" poster="../../assets/video.png">
                    <source src='/video/1234.mp4' type="video/mp4" />
					<!-- <source :src='videoSrc' type="video/ogg" /> -->
					
                  </video>
                      <div class="bor" v-if="isPlay">
                        <div class="txt11">核心中台产品</div>
                        <div class="core">Core midrange products</div>
                      </div>
                  </div>
                      <!-- <MyVideo class="kuan1" v-bind:videoSrc="videoSrc"/> -->
                  </Col>

                  <Col span="6" style=" margin-left: -0.3rem;">
                    <div>
                      <div class="home-content3-video3 pp2">
                        <MyVideo videoSrc="/video/2345.mp4" @yr='yr1' @yc='yc1'/>
                        <div class="bor2" v-if="isPlay1">
                          <div class="txt12">智慧园区</div>
                          <div class="core2">Smart factory</div>
                        </div>
                      </div>
                      <div class="home-content3-video3 home-content3-video3_3 pp3">
                        <MyVideo videoSrc="/video/3456.mp4" @yr='yr2' @yc='yc2'/>
                        <div class="bor3" v-if="isPlay2">
                          <div class="txt13">智慧工厂</div>
                          <div class="core3">Smart factory</div>
                        </div>
                      </div>
                      <!-- <div class="home-content3-video3">
                        <MyVideo v-bind:videoSrc="videoSrc"/>
                      </div> -->
                    </div>
                  </Col>
                </Row>

                <Row style="padding-right: 0.3rem;margin-left: -7px;margin-right: -7px ;margin-top: 9px;" :gutter="20">
                  <Col span="6">
                    <div class="home-content3-video4 pp4">
                       <MyVideo videoSrc="/video/4567.mp4" @yr='yr3' @yc='yc3'/>
                        <div class="bor4" v-if="isPlay3">
                          <div class="txt14">物联平台</div>
                          <div class="core4">IoT Platform</div>
                        </div>
                    </div>
                  </Col>
                  <Col span="6">
                    <div   class="home-content3-video4 pp5">
                        <MyVideo videoSrc="/video/5678.mp4" @yr='yr4' @yc='yc4'/>
                        <div class="bor5" v-if="isPlay4">
                          <div class="txt15">集成平台</div>
                          <div class="core5">Integrated platform</div>
                        </div>
                    </div>
                  </Col>
                  <Col span="6">
                    <div  class="home-content3-video6">
                    <MyVideo videoSrc="/video/6789.mp4" @yr='yr5' @yc='yc5'/>
                        <div class="bor6" v-if="isPlay5">
                          <div class="txt16">数据中台</div>
                          <div class="core6">Data center station</div>
                        </div>
                    </div>
                  </Col>
                     <Col span="6">
                    <div  class="home-content3-video4 pp7">
                      <MyVideo videoSrc="/video/7890.mp4" @yr='yr6' @yc='yc6'/>
                       <div class="bor7" v-if="isPlay6">
                          <div class="txt17">综合运维</div>
                          <div class="core7">Integrated O&M</div>
                        </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
      </Col>
      <Col span="2"></Col>
    </Row>
    <a href="#fourPage">
      <div style="margin-top: -0.3rem;">
        <Arrow/>
      </div>
    </a>
    <a name="fourPage"></a>
  </div>
</template>

<script>
  import MyVideo from '@/util/MyVideo.vue'
  import Arrow from '@/pages/components/Arrow'
  export default {
    name: 'HomeContent3',
    components:{MyVideo,Arrow},
    data() {
        return {
          videoSrc: "https://ks-stock4.xpccdn.com/3b9e4190-6d3d-434b-a094-19a484995cc1.mp4",
          isPlay:true,
          isPlay1:true,
            isPlay2:true,
              isPlay3:true,
                isPlay4:true,
                  isPlay5:true,
                  isPlay6:true,
        };
      },
       methods:{
  play(){
         this.$refs.kuan1.play();
         this.isPlay = false
     },
     pause(){
   this.$refs.kuan1.pause();
   this.isPlay = true
     },
     yr1(){
    this.isPlay1 = false
     },
     yc1(){
  this.isPlay1 = true
     },
          yr2(){
    this.isPlay2 = false
     },
     yc2(){
  this.isPlay2 = true
     },
               yr3(){
    this.isPlay3 = false
     },
     yc3(){
  this.isPlay3 = true
     }
     ,
      yr4(){
    this.isPlay4 = false
     },
     yc4(){
  this.isPlay4 = true
     },
    yr5(){
    this.isPlay5 = false
     },
     yc5(){
  this.isPlay5 = true
     },
         yr6(){
    this.isPlay6 = false
     },
     yc6(){
  this.isPlay6 = true
     },
       go(){
         this.resetSetItem('index','3');
       }

       }
  }

</script>

<style >
.player_kuan1{
  position: relative;
}
.bor{
   position: absolute;
   left: 50%;
   top: 50%;
   margin-left: -125px;
   margin-top: -35.2px;
}
.txt11{
  color: white;
  font-size: 25px;
  /* border: 1px solid white; */
  padding: 3px 50px;
}
.pp2{
  position: relative;
}
.bor2{
    position: absolute;
   left: 50%;
   top: 20%;
   margin-left: -35.675px;
}
.core{
    margin-top: 10px;
   color: white;
   font-size: 12px;
}
.txt12{
  color: wheat;
  font-size: 16px;
}
.core2{
  color: wheat;
  font-size: 12px;
}

.pp3{
  position: relative;
}
.bor3{
    position: absolute;
   left: 50%;
   top: 20%;
   margin-left: -35.675px;
}
.txt13{
  color: wheat;
  font-size: 16px;
}
.core3{
  color: wheat;
  font-size: 12px;
}

.pp4{
  position: relative;
}
.bor4{
    position: absolute;
   left: 50%;
   top: 20%;
      margin-left: -32.57px;
}
.txt14{
  color: wheat;
  font-size: 16px;
}
.core4{
  color: wheat;
  font-size: 12px;
}
.pp5{
  position: relative;
}
.bor5{
    position: absolute;
   left: 50%;
   top: 20%;
    margin-left: -46.48px;
}
.txt15{
  color: wheat;
  font-size: 16px;
}
.core5{
  color: wheat;
  font-size: 12px;
}
.pp6{
  position: relative;
}
.bor6{
    position: absolute;
   left: 50%;
   top: 20%;
       margin-left: -50.365px;
}
.txt16{
  color: wheat;
  font-size: 16px;
}
.core6{
  color: wheat;
  font-size: 12px;
}
.pp7{
  position: relative;
}
.bor7{
    position: absolute;
   left: 50%;
   top: 20%;
          margin-left: -42.355px;
}
.txt17{
  color: wheat;
  font-size: 16px;
}
.core7{
  color: wheat;
  font-size: 12px;
}
  .my-home-content3{
    text-align: center;
    padding-bottom: 0.75rem;
  }
  .my-home-content3 h2{
	font-family: Nowar-CC-Warcraft-CN-Bold;

	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #ffffff;

    font-size: 0.25rem;
    margin-bottom: 0.25rem;
    letter-spacing:0.02rem;
    margin-top: -0.5rem;
  }
  .span13{
	font-family: SourceHanSansCN-Light;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #ffffff;
  }
  .span23{
	font-family: SourceHanSansCN-Light;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #009bff;
  cursor: pointer;
  }
  .my-content3{
    height:  7.36rem;
    padding-left: 0.25rem;
    padding-top: 0.9rem;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-image: url(../../assets/img/home-conten3-video-bg.png);
  }

  .home-content3-video1{
    padding: 0 0.3rem 0.1rem 0.1rem;
    width: 100%;
    height: 4.1rem;
  }
.kuan1{
   /* width: 7.68rem; */
     /* width: 5rem;  */
     object-fit: fill;
     width:99%;
  height: 100%;
      border-radius: 0.1rem;
      padding-right: 0.055rem;
      border: none;
}
  .home-content3-video3{
       width: 3.33rem;
    height: 2.12rem;
    border-radius: 0.1rem;
          margin-left: 0.05rem;
          border: none;
    /* margin-top: 20px; */
  }
  .home-content3-video4{
    width: 3.35rem;
    height: 2.2rem;
    border-radius: 0.1rem;
    border: none;
  }
.video-js .vjs-tech{
   border-radius: 0.1rem;
   border: none;
}
.video-js.vjs-fluid, .video-js.vjs-16-9, .video-js.vjs-4-3, .video-js.vjs-9-16, .video-js.vjs-1-1{
   border-radius: 0.1rem;
   border: none;
}
.box_hz{
  width: 100%;
  height: 100%;
}
.hz_g{
  height: 4.15rem;
}
.home-content3-video3_3{
    /* margin-top: 0.08rem; */
}
.vjs-has-started .vjs-control-bar{
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/home-content/HomeContent3.vue